import Form from '@components/Form'
import React, {useState, useEffect, useRef} from 'react'
import Spacer from '@components/Spacer'
import Container from '@components/Container'
import { colors } from '@styles/vars/colors.style'
import CMSLink from '@components/CMSLink'
import { useForm } from 'react-hubspot'
import axios from 'axios'
import RichText from '@components/RichText'

import {
  PdfFromContainer,
  PdfFromSideContainer,
  PdfFromInner,
  FormTitle,
  OpenButton
} from './index.style'
const PdfForm = (
  {
    fullView,
    backgroundColor = '#ffd099',
    color = 'currentColor',
    newsletterLabel, 
    formId, 
    formTitle,
    thanksMessage,
    customButtonTitle,
    downloadButtonTitle,
    removeLastCheck,
    privacyPolicyCheckText
  }) => {
  const links = {
        "privacy-policy" : {
          "contentful_id": "79jDtiNOndNcVffIZq3Ts8",
          "text": "Privacy policy",
          "page": {
            "contentful_id": "63dmy6B6QHsVLeVtNXs6rp",
            "slug": "privacy-policy",
            "internal": {
              "type": "ContentfulStandardContent"
            }
          }
        },
        "terms-of-use" : {
          "contentful_id": "46xlbh7rvhOxxIh7Fd0o1g",
          "text": "Terms of use",
          "page": {
            "contentful_id": "1sJBq7f7j5YmUe2kkmeTP5",
            "slug": "terms-of-use",
            "internal": {
              "type": "ContentfulStandardContent"
            }
          }
        }
  }
  const [returnedData, setReturnedData] = useState();
  const [pdfUrlLink, setPdfUrlLink] = useState();
  const [pdfUrlName, setPdfUrlName] = useState();
  const [confirmState, setConfirmState] = useState(false);
  const [downloadedFile, setDownloadedFile] = useState(null);
  const [customState, setCustomState] = useState(null);
  const { data, isLoading, isError, handleSubmit } = useForm({
    portalId: '25832621',
    formId: formId || 'ceb1def8-dffa-4add-b667-af7cff892888'
  })
  useEffect(()=>{
    if(data?.data.redirectUri) {
      fetchData(data.data.redirectUri);
    }else if (data?.data.inlineMessage){
      setCustomState(<div dangerouslySetInnerHTML={{ __html: data?.data.inlineMessage }} />);
    }
  },[data]);

  const agreementCheckboxLabel = (
      privacyPolicyCheckText ?
      <RichText content={privacyPolicyCheckText} />
      :
      <>l agree to the <CMSLink link={links['terms-of-use']} /> and <CMSLink link={links['privacy-policy']} />.</>

  );

  const formConfig = [
    {
      type: 'input',
      name: 'firstname',
      label: 'First name*',
      required: true,
    },
    {
      type: 'input',
      name: 'lastname',
      label: 'Last name*',
      required: true,
    },
    {
      type: 'email',
      name: 'email',
      label: 'Email*',
      required: true,
    },
    {
      type: 'input',
      name: 'company',
      label: 'Company*',
      required: true,
    },
    {
      type: 'input',
      name: 'jobtitle',
      label: 'Job Title*',
      required: true,
    },
    {
      type: 'checkbox',
      name: 'yes__i_do__i_agree_to_the_terms___conditions_and_privacy_policy_',
      label: agreementCheckboxLabel,
      required: true,
    }
  ]
  const thxMessage = thanksMessage || 'Thanks for downloading, enjoy!'

  const downloadButton= useRef(null);
  const handleClick = () => {
      downloadButton.current.click();
  }

  const pdfDownload = (blob, file) => {
      var filename = file.replace(/^.*[\\\/]/, '')
      const url = window.URL.createObjectURL(new Blob([blob], {type: 'application/pdf'}))
      if(url) {
        setPdfUrlLink(url);
      }else {
        setPdfUrlLink(file);
      }
      setPdfUrlName(filename);
      handleClick()
      setConfirmState(true);
      setCustomState('hide');
  }

  const fetchData = async (file) => {
    setCustomState('Loading ');
    var file = file.toString();
    try {
      const result = await axios.get(file, { 
        responseType: 'blob',
        onDownloadProgress: progressEvent => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setCustomState('Loading - ' + percentage + '%')
        },
      })
      .then(function (res) {
        pdfDownload(res.data,file )
      })
      .catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
    } catch (e) {
      console.log(e);
    }
  }


  const formSignupText = (<p> Sign up to this form</p>);
  const formInner = (
      <PdfFromInner>
        {formTitle && <FormTitle>{formTitle}</FormTitle>}
        <Form
          name="Pdf form"
          config={formConfig}
          formSignupText={formSignupText}
          onSuccess={pdfDownload}
          successText={'Thanks for downloading, enjoy!'}
          buttonColor={color}
          customSubmit={handleSubmit}
          customState={customState}
          formData={returnedData}
          customButtonTitle={customButtonTitle}
          removeLastCheck={!confirmState}
        />
        <OpenButton className={!confirmState && 'hidden'} ref={downloadButton} href={pdfUrlLink} download={pdfUrlName} target="_system">{downloadButtonTitle ? downloadButtonTitle : 'Read Now'}</OpenButton>
      </PdfFromInner>
  )

  return (
    <>
    {fullView && 
      <PdfFromContainer color={color} backgroundColor={backgroundColor}>
      {formInner}
      </PdfFromContainer>
    }
    {!fullView && 
      <PdfFromSideContainer color={color} backgroundColor={backgroundColor}>
      {formInner}
      </PdfFromSideContainer>
    }
    
    </>
  )
}

export default PdfForm
